/* eslint-disable no-console */
import { race, delay, call, put, takeEvery, spawn } from 'redux-saga/effects'

import actions from 'models/General/actions'
import api from 'models/General/api'
import fetchIpAddress from 'utils/ip-address'
import sentry from 'services/Sentry'

function* setIpAddress() {
  try {
    const { ipAddress } = yield call(fetchIpAddress)
    yield put(actions.setIpAddress.success(ipAddress))
  } catch (error) {
    console.error('[General] setIpAddress:', error)
  }
}

const timeoutMs = 30000

function* initApp({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let region = null
  yield spawn(setIpAddress)
  try {
    const { response, timeout } = yield race({
      response: call(api.getRoot),
      timeout: delay(timeoutMs),
    })

    if (timeout) {
      console.error('[General] initApp: Timeout on getRoot')
      yield put(actions.setRegion.failure({ region: null, ipAddress: null }, true))
      yield put(actions.initApp.failure())
      return
    }
    region = response.region
    yield put(actions.setRegion.success(region))
    isSuccess = true
    yield put(actions.initApp.success())
  } catch (error) {
    console.error('[General] initApp: ', error)
    const { responseJson, isNoInternetError } = error
    yield put(actions.setRegion.failure(responseJson, isNoInternetError))
    yield put(actions.initApp.failure())
  } finally {
    yield call(sentry.setRegion, region)
    if (callback) {
      callback(isSuccess)
    }
  }
}

function* fetchSecureConstants() {
  try {
    const response = yield call(api.fetchSecureConstants)
    yield put(actions.fetchSecureConstants.success(response))
  } catch (error) {
    console.error('[General] fetchSecureConstants:', error)
    yield put(actions.fetchSecureConstants.failure(error))
  }
}

function* fetchConstants() {
  try {
    const response = yield call(api.fetchConstants)
    yield put(actions.fetchConstants.success(response))
  } catch (error) {
    console.error('[General] fetchConstants:', error)
    yield put(actions.fetchConstants.failure(error))
  }
}

export function* fetchIntercomUserHash({ payload }) {
  const { callback } = payload
  let isSuccess = false
  try {
    const result = yield call(api.fetchIntercomUserHash)
    yield put(actions.fetchIntercomUserHash.success(result))
    isSuccess = true
  } catch (error) {
    console.error('[General] fetchIntercomUserHash:', error)
    yield put(actions.fetchIntercomUserHash.failure(error))
  }
  if (callback) {
    yield call(callback, isSuccess)
  }
}

function* main() {
  yield takeEvery(actions.initApp.INIT_TYPE, initApp)
  yield takeEvery(actions.fetchSecureConstants.INIT_TYPE, fetchSecureConstants)
  yield takeEvery(actions.fetchConstants.INIT_TYPE, fetchConstants)
  yield takeEvery(actions.fetchIntercomUserHash.INIT_TYPE, fetchIntercomUserHash)
}

export default {
  initApp,
  setIpAddress,
  main,
  fetchSecureConstants,
  fetchConstants,
}
